import { STANDARD_RISK_WARNING } from "../constants/compliance";
import { AlertCircle } from "lucide-react";

export default function RiskWarning() {
  return (
    <div className="risk-warning flex items-start gap-2 p-4 bg-[#1a1410]/30 border border-[#8b7355]/50 rounded-lg" data-testid="risk-warning">
      <AlertCircle className="w-5 h-5 text-[#d4af69] flex-shrink-0 mt-0.5" />
      <p className="text-sm text-gray-300">
        {STANDARD_RISK_WARNING}
      </p>
    </div>
  );
}